<template>
    <Link :href="href" :class="[activeClass]" class="group flex items-center justify-between p-3 rounded-md" aria-current="page">
        <slot />
    </Link>
</template>

<script>
export default {
    props: {
        href: {
            required: true,
        },
        active: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        activeClass() {
            return this.active ? "bg-gray-200 dark:bg-slate-800 text-gray-700 dark:text-slate-200" : "text-gray-600 dark:text-slate-500 hover:text-gray-500 dark:hover:text-slate-400 hover:bg-white dark:hover:bg-slate-900"
        },
    },
}
</script>
